<template>
  <div class="history">
    <div>
      <el-header style="font-size: 20px;color: #5d5c5c;line-height: 60px;margin: 0 20px">更新日志</el-header>
      <el-main style="background: #ffffff;margin: 0 20px">
        <el-card shadow="hover" v-for="item in historyData" style="margin-top: 10px" :key="item.ordernum">
          <div class="version">
            <i class="el-icon-circle-check" />{{ item.versionCode }}
          </div>
          <code class="time">
            {{ item.updateTime }}
          </code>
          <ul v-for="(des,index) in item.sysVersionList" :key="index" class="text">
            <li>{{ des.ordernum }}、{{ des.versionDescribe }}</li>
          </ul>
        </el-card>
      </el-main>
    </div>
  </div>
</template>

<script>
import API from '../api';
export default {
  name: 'HistoryRecord',
  data () {
    return {
      historyData: []
    };
  },
  methods: {
    getHistoryList () {
      API.getSysVersionHistory().then((res) => {
        if (res.data.status === '200') {
          this.historyData = res.data.data;
        }
      });
    }
  },
  mounted () {
    this.getHistoryList();
  }
};
</script>

<style type="text/css" scoped>
  .history{
    background: #ECF0F1;
    height: 100%;
    text-align:left;
  }
  el-header{

  }

  .history .version{
    font-size: 16px;
  }
  .history .version .el-icon-circle-check{
    color: #37BADE;
    margin-right: 4px;
    font-size: 18px;
  }
  .history .time{
    display: inline-block;
    background: #f7f7f7;
    margin: 6px 0px;
    padding: 1px 5px;
    border-radius: 3px;
    color: #666;
    border: 1px solid #eee;
  }

  .history .text{
    margin-bottom: 5px;
    font-size: 14px;
  }

  .history .box-card {
    width: 480px;
  }
  .el-main {
    text-align: left;
  }
</style>
